import { jsx } from 'panel';
import { DropMenuEl } from 'common/components/drop-menu';
import { CreateEntityModalEl } from 'common/widgets/create-entity-modal';
import { InputEl } from 'common/components/input';
import { PopoverCardEl } from 'common/components/popover-card';
import { PropertiesMenuEl } from 'common/widgets/query-block/properties-menu';
import { VIEWS } from './types';
export function template() {
  const {
    dropMenuOpen,
    keydownProxyEl,
    searchFilter,
    view
  } = this.state;
  return jsx("div", {
    sel: '.actions-popover-container'
  }, jsx(DropMenuEl, {
    attrs: {
      open: this.attr("open") && dropMenuOpen,
      'prevent-close-selectors': JSON.stringify(["mp-create-entity-modal", ...this.attr("prevent-close-selectors")])
    },
    on: {
      change: this.helpers.handleDropMenuChange,
      click: ev => ev.stopPropagation()
    }
  }, view === VIEWS.CREATE_COHORT ? jsx(CreateEntityModalEl, {
    attrs: this.helpers.getCohortModalAttributes(),
    on: {
      save: this.helpers.handleCohortSaved,
      saveAndShare: this.helpers.handleCohortSaved,
      cancel: this.helpers.handleCohortCanceled,
      modalClosed: this.helpers.handleModalClose
    },
    props: {
      existingEntityNames: this.attr("cohort-names")
    }
  }) : view === VIEWS.BREAKDOWN ? jsx(null, null, jsx("div", {
    sel: '.context-menu-search-wrapper'
  }, jsx(InputEl, {
    attrs: {
      icon: "search",
      placeholder: "Search",
      value: searchFilter
    },
    on: {
      input: this.helpers.handleSearchInput
    },
    hook: {
      insert: this.helpers.addKeydownProxyEl
    }
  })), jsx(PropertiesMenuEl, {
    attrs: {
      'disabled-items': JSON.stringify(this.helpers.breakdownDisabledItemsMap()),
      'event-names': JSON.stringify([this.attr("event")]),
      open: this.attr("open"),
      'project-id': this.helpers.getProjectId(),
      'workspace-id': this.attr("workspace-id"),
      'search-filter': searchFilter
    },
    on: {
      select: this.helpers.handleBreakdownMenuSelect
    },
    props: {
      keydownProxyEl
    }
  })) : jsx(PopoverCardEl, {
    attrs: {
      'button-options': this.attr("button-options"),
      title: this.attr("title"),
      subtitle: this.attr("subtitle"),
      'is-segmented': this.attr("is-segmented")
    },
    on: {
      action: this.helpers.handlePopoverAction,
      close: this.helpers.handlePopoverClose
    }
  }, jsx("slot", null))));
}